var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895432 0 2V10.8C0 11.9046 0.895433 12.8 2 12.8H8.75862C9.86319 12.8 10.7586 11.9046 10.7586 10.8V2C10.7586 0.895431 9.86319 0 8.75862 0H2ZM15.2414 11.2C14.1368 11.2 13.2414 12.0954 13.2414 13.2V22C13.2414 23.1046 14.1368 24 15.2414 24H22C23.1046 24 24 23.1046 24 22V13.2C24 12.0954 23.1046 11.2 22 11.2H15.2414ZM0 18C0 16.8954 0.895431 16 2 16H8.75862C9.86319 16 10.7586 16.8954 10.7586 18V22C10.7586 23.1046 9.86319 24 8.75862 24H2C0.895433 24 0 23.1046 0 22V18ZM15.2414 0C14.1368 0 13.2414 0.895431 13.2414 2V6C13.2414 7.10457 14.1368 8 15.2414 8H22C23.1046 8 24 7.10457 24 6V2C24 0.895431 23.1046 0 22 0H15.2414Z",
    fill: "#032142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.3f8d3b80.svg";
export { ForwardRef as ReactComponent };